var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('the-mobile-nav'),_vm._v(" "),_c('baker-events-nav'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }